module.exports = __webpack_public_path__ + "img/svk.b84444bf.svg";